/**
 * With thanks to https://byby.dev/js-slugify-string
 */

import { removeAccents } from "./removeAccents";

export const slugify = (value: string): string => {
    return removeAccents(value)
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9 -]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");
};
